import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    selectedCoupon: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.MY_COUPONS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.MY_COUPONS_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.MY_COUPONS_FAILURE:
      return {
        data: [],
        error: action.error,
        isProgress: false,
      };
    case homeConstants.SELECTED_COUPON_INFO: {
      if (action?.data) {
        localStorage.setItem("selectedCouponItem", JSON.stringify(action.data));
      }
      return {
        ...state,
        selectedCoupon: action.data,
      };
    }
    default:
      return state;
  }
}
